/**
 * Small helpers the shell and the dashboards share.
 *
 * In their own module because a file that exports both components and plain
 * functions loses React Fast Refresh for every component in it.
 */

/** Two letters is enough identity for a 32px circle. */
export function initials(name) {
  if (!name) return '?';
  return (
    name
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0].toUpperCase())
      .join('') || '?'
  );
}

/** Today, spelled out -- the line under the name in the greeting banner. */
export function todayLine(date = new Date()) {
  return date.toLocaleDateString(undefined, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
